// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import BarChartOutlined from 'D:/erp开发/erp-app/digitalDashboard/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BarChartOutlined';
import PieChartOutlined from 'D:/erp开发/erp-app/digitalDashboard/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/PieChartOutlined';
import SettingOutlined from 'D:/erp开发/erp-app/digitalDashboard/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { BarChartOutlined, PieChartOutlined, SettingOutlined };
